import { ControlPanelWrapper } from "./MaterialCustomComponents/ControlPanelComponents";
import ChangeCameraFiberComponent from "./fiber-components/ChangeCameraFiberComponent";
import ChangeBoothFiberComponent from "./fiber-components/ChangeBoothFiberComponent";
import ChangeHallFiberComponent from "./fiber-components/ChangeHallFiberComponent";
import IThreeFiberComponent from "../interfaces/IThreeFiberComponent";
import ArrowNavigation from "./NavigationMenu/ArrowNavigation";
import FooterSection from "./NavigationMenu/FooterSection";
import Image from "next/image";
import { BlackBgBanner, SimpleBox } from "./MaterialCustomComponents";
import { useRouterStore } from "../store/useRouterStore";
import BoothContactForm from "./Contact-form/BoothContactForm";
import BoothOfferBanner from "./BoothOfferBanner";
import { useComponentLoadingStateStore } from "../store/useComponentLoadingStateStore";
import { useEffect, useRef } from "react";
import { useWindowSize } from "../hooks/useWindowSize";
import ControlPanelDesktop from "./GenericLayout/ControlPanelDesktop";
import { useScreenOrientation } from "../hooks/useScreenOrientation";
import { openStripes } from "../animations/animateStripes";
import { updateRoute } from "../helpers/updateBoothURL";
import SafariVideoComponent from "./fiber-components/SafariVideoComponent";
import { useMobileBrowser } from "../hooks/useMobileBrowser";
import { LinearProgress } from "@mui/material";
import MobileIndicators from "./Mobile-indicators/MobileIndicators";

const ControlPanel: IThreeFiberComponent = () => {
  const { isOffersBoxClicked } = useComponentLoadingStateStore();
  const { boothID } = useRouterStore();
  const controlPanelRef: any = useRef();
  const { width, height } = useWindowSize();
  const { landscape } = useScreenOrientation();
  const { isMobileBrowser } = useMobileBrowser();

  const calculateHeight = () => {
    if (typeof window === "undefined") return;
    controlPanelRef.current.style.height = `${window.innerHeight}px`;
  };

  useEffect(() => {
    if (!height) return;
    calculateHeight();
  }, [height]);

  return (
    <ControlPanelWrapper ref={controlPanelRef}>
      <BlackBgBanner className="black-bg-banner">
        <LinearProgress variant="indeterminate" color="white" />
      </BlackBgBanner>
      <BoothContactForm boothID={boothID} />
      <MobileIndicators />
      {isOffersBoxClicked && <BoothOfferBanner isOpen={isOffersBoxClicked} />}
      <SimpleBox sx={{ opacity: !boothID ? 1 : 0 }}>
        {landscape || width >= 600 ? (
          <Image
            src="/logo.svg"
            alt="ktirio logo"
            width={landscape ? 80 : 160}
            height={landscape ? 40 : 85}
            onClick={() => openStripes(() => updateRoute("/"))}
            style={{
              pointerEvents: "auto",
              cursor: "pointer",
            }}
          />
        ) : (
          <Image
            src="/logo.svg"
            alt="ktirio logo"
            width={120}
            height={65}
            onClick={() => openStripes(() => updateRoute("/"))}
            style={{
              pointerEvents: "auto",
              cursor: "pointer",
            }}
          />
        )}
      </SimpleBox>
      {isMobileBrowser && (
        <>
          <ArrowNavigation isDeviceOnLandscape={landscape} />
          <FooterSection isDeviceOnLandscape={landscape} />
        </>
      )}
      {!isMobileBrowser && <ControlPanelDesktop />}
      <SafariVideoComponent />
    </ControlPanelWrapper>
  );
};

ControlPanel.r3f = () => {
  return (
    <>
      <ChangeBoothFiberComponent />
      <ChangeHallFiberComponent />
      <ChangeCameraFiberComponent />
    </>
  );
};

export default ControlPanel;
